<section class="e-quote-stepper-forms stepper-form" *ngIf="projectID">
    
 <div class="d-block d-lg-flex align-items-center bg-white justify-content-between container-fluid e-logo-content position-relative">
        <div class="d-flex align-items-center col-12 col-lg-3 e-logo-container ">
            <div class="m-3">
                <a (click)="OnClickLogo()">
                  <img class="main-logo" [src]="getImagePath+'logo.svg'" alt="Rio Logo" width="40px" height="auto">
                </a>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  
              </div>
              <div>
                <div class="new-test d-flex align-items-center">
                    <div class="text-wrap-dot-stepper" [title]="projects.vProjectName">{{projects.vProjectName}}</div>
                    <button type="button" class="bg-transparent border-0" title="Edit Project"
                        (click)="EditProjectDetailsModal(editprojectdetails)"><img class="logo"
                            [src]="getImagePath+'edit-stepper.svg'" alt="Logo" width="16px" height="16px"></button>
                </div>
                <!-- <div class="text-wrap-dot-stepper short-desc">{{projects.vDescription}}</div> -->
              </div>
        </div>
        <div class=" col-12 col-lg-6">
            <div class="  stepper-section">
            <mat-horizontal-stepper [linear]="isLinear" #stepper labelPosition="bottom" class="matHorizontalStepper"
                (selectionChange)="updateStepContent($event.selectedIndex)" [(selectedIndex)]="activeStepIndex">
                <ng-template matStepperIcon="edit">
                    <mat-icon>radio_button_checked</mat-icon>
                </ng-template>
                <!-- Service Requirement -->
                <mat-step [completed]="getStatus(0).completed" [stepControl]="serviceForm" aria-disabled="false">
                    <ng-template matStepLabel>
                        <div class="stepLabel " [ngClass]="getStatus(0).className">
                            <div class="label-status-one"> Service Requirement </div>
                            <div id="label-status-two-0" class="label-status-two" [ngClass]="getStatus(0).className">{{
                                getStatus(0).status }}</div>
                        </div>
                    </ng-template>
                    <ng-template #step1Content>
                      
                        <app-service-req class="" (nextStep)="navigateToStep(1)"></app-service-req>
                    </ng-template>
                </mat-step>
                <!-- Project Documents -->
                <mat-step [completed]="getStatus(1).completed" [stepControl]="productForm" aria-disabled="false">
                    <ng-template matStepLabel>
                        <div class="stepLabel" [ngClass]="getStatus(1).className">
                            <div class="label-status-one"> Project Documents </div>
                            <div id="label-status-two-1" class="label-status-two" [ngClass]="getStatus(1).className">{{
                                getStatus(1).status }}</div>
                        </div>
                    </ng-template>

                    <ng-template #step2Content>
                        <app-project-docs class="" (nextStep)="navigateToStep(2)"></app-project-docs>
                    </ng-template>
                </mat-step>
                <!-- View Quotation -->
                <mat-step [completed]="getStatus(2).completed" aria-disabled="false">
                    <ng-template matStepLabel>
                        <div class="stepLabel" [ngClass]="getStatus(2).className">
                            <div class="label-status-one"> View Quotation</div>
                            <div id="label-status-two-2" class="label-status-two" [ngClass]="getStatus(2).className">{{
                                getStatus(2).status }}</div>
                        </div>
                    </ng-template>
                    <ng-template #step3Content>
                        <app-view-e-quote class="" (userDetails)="getUser($event)"></app-view-e-quote>
                    </ng-template>
                </mat-step>
            </mat-horizontal-stepper>
        </div>
       </div>
        <div class="col-3 d-flex justify-content-end e_quote-menu">
            <div *ngIf="isEQuoteRoute()" class="right-side d-flex">
                <div class="profile-btn d-flex" [matMenuTriggerFor]="profilemenu">
                  <div class="mx-2">
                    <img [src]="userDetails?.vProfilePhoto || getImagePath + 'avatar.svg'" alt="user" class="avatar" />
                  </div>
                  <div class="">
                    <p class="user-name cursor-pointer">{{ userDetails?.vName }}</p>
                  </div>
                  <mat-menu #profilemenu="matMenu" class="header-matmenu header-matmenu_box">
                    <!-- <button mat-menu-item [routerLink]="['/customer/profile']">Profile</button> -->
                    <button mat-menu-item (click)="ChangePassword()">Change Password</button>
                    <button mat-menu-item (click)="HandleLogout()">Sign Out</button>
                  </mat-menu>
                </div>
              </div>
        </div>
    </div>
    
    <div class="stepper-content p-2">
        <ng-container [ngSwitch]="stepContent">
            <ng-container *ngSwitchCase="'content-1'">
                <ng-container *ngTemplateOutlet="step1Content"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'content-2'">
                <ng-container *ngTemplateOutlet="step2Content"></ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="'content-3'">
                <ng-container *ngTemplateOutlet="step3Content"></ng-container>
            </ng-container>
        </ng-container>
    </div>
</section>

<ng-template #editprojectdetails let-c="close" let-d="dismiss">
    <div class="modal-dialog modal-dialog-centered m-0">
        <div class="edit-project-dialog modal-content">
            <div class="d-flex flex-column align-items-center relative">
                <img class="logo" [src]="getImagePath+'edit-project.svg'" alt="Logo" height="40" width="40">
                <div class="improved-page-label">Edit Project Details</div>
                <button type="button" class="close-btn btn" aria-label="Close" (click)="d('Cross click')">
                    <img [src]="getImagePath+'close-icon.svg'" alt="Close" height="15" width="15">
                </button>
            </div>
            <div class="form-container">
                <form class="custom-create-project-form" id="editProjectForm" [formGroup]="editProjectForm">
                    <div class="form-control-box bottom-spacing">
                        <label for="vProjectName" class="label">Project Name<span class="text-danger">*</span></label>
                        <div>
                            <mat-form-field appearance="outline" class="improved-input w-100">
                              <input matInput id="name" placeholder="Enter Project Name" formControlName="vProjectName"
                              (input)="editProjectForm.invalid">
                            </mat-form-field>
                          </div>
                          <div class="input-details-box no-mat-input justify-content-end">
                          <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                            *ngIf="hasError(editProjectForm, 'vProjectName', 'required')">
                            Project Name is required.
                          </mat-error>
                          <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                            *ngIf="hasError(editProjectForm, 'vProjectName', 'maxlength')">
                            Must not exceed 100 characters.
                          </mat-error>
                          <mat-error class="w-100 increase-z-index error-top-spacing error-message"
                            *ngIf="hasError(editProjectForm, 'vProjectName', 'pattern')">
                            Please enter valid name.
                          </mat-error>
                        </div>
                    </div>
                    <div class="w-100 d-flex justify-content-end mt-3"> 
                        <button class="btn btn-primary improved-add-btn" [disabled]="!editProjectForm.dirty || editProjectForm.invalid"
                            [ngClass]="{'disabled-button': !editProjectForm.dirty || editProjectForm.invalid}" (click)="EditProject()">Update</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</ng-template>
